import { Injectable } from '@angular/core';
import {ResourcesService} from '../resources.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class SupplierService {

  constructor(private _resourcesService: ResourcesService) { }

  getAnonymSupplier(supplierId: number | string): Observable<any> {
    return this._resourcesService.get('supplier/GetAnonymSupplier?supplierId=' + supplierId, false);
  }

  findPromocode(supplierId: string | number, promocode: string): Observable<any> {
    return this._resourcesService.get('supplier/WidgetFindPromocode?supplierId=' + supplierId + '&promocode=' + promocode);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/api/resources/supplier/supplier.service.ts